module.exports = __webpack_public_path__ + "static/media/Muhannad.f5f12691.jpeg";